import React, { useState } from 'react'
//import MongoContext from './MongoContext'
import { mongodb, auth, useAuth } from './Auth//use-auth'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import CssBaseline from '@material-ui/core/CssBaseline'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import { useParams } from 'react-router-dom'
import { useFormik, ErrorMessage } from 'formik'
import * as yup from 'yup'

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    width: 'auto',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      width: 600,
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  buttons: {
    width: '80%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    width: 'auto',
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.dark
  },
  error: {
    border: '4px solid ',
    color: '#ff1744'
  },
  textField: {
    textTransform: 'capitalize'
  }
}))

export default function ViewCar (props) {
  const classes = useStyles()
  const { auth, user } = useAuth()
  const [carInfo, setCarInfo] = useState([])
  const { carId, clientName } = useParams()
  const db = mongodb.db('silmandDB')

  const LoginValidation = yup.object().shape({
    carNr: yup
      .string()
      .min(1, '*Numbris ei tohi olla alla 1 märgi')
      .max(6, '*Numbris ei tohi olla üle 6 märgi')
      .required('*Number on kohustuslik')
  })
  const AutenthValidation = yup.object().shape({
    user: yup.string().required(() => {
      window.alert('Vaja sisse logida')
    })
  })
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: {
      carId: carId,
      clientName: clientName,
      aliasName: carInfo.aliasName,
      carNr: carInfo.carNr,
      carModel: carInfo.carModel,
      carOdo: carInfo.carOdo,
      driverInfo: carInfo.driverInfo,
      carHistory: carInfo.carHistory
    },

    onSubmit: values => {
      //alert(JSON.stringify(values, null, 2))
      changeCarData(values)
    },
    validationSchema: LoginValidation
  })

  React.useEffect(() => {
    if (user) {
      const readCarData = async carId => {
        try {
          const dbCars = db.collection('clientCars')

          return await dbCars
            .find({ _id: parseInt(carId) })
            .asArray()
            .then(putToCarInfo)
        } catch (e) {
          console.log('item find viga', e)
        } finally {
        }
      }

      const putToCarInfo = async dbCars => {
        await dbCars.map(dbcar => {
          setCarInfo({
            aliasName: dbcar.aliasName,
            carNr: dbcar.carNr,
            carModel: dbcar.carModel,
            carOdo: dbcar.carOdo,
            driverInfo: dbcar.driverInfo,
            carHistory: dbcar.carHistory
          })
          return true
        })
      }

      readCarData(carId)
    } else {
      window.alert('Vaja sisse logida')
      props.history.push('/')
    }
  }, [])

  const changeCarData = async value => {
    try {
      await db.collection('clientCars').updateOne(
        { _id: parseInt(value.carId) },
        {
          $set: {
            aliasName: value.aliasName,
            carNr: value.carNr,
            carModel: value.carModel,
            carOdo: value.carOdo,
            driverInfo: value.driverInfo,
            carHistory: value.carHistory
          }
        }
      )
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      props.history.go(-1)
    }
  }

  const handleCancel = () => {
    //className={formik.touched.carNr && formik.errors.carNr ? classes.error : null}
    props.history.go(-1)
  }
  return (
    <React.Fragment>
      <CssBaseline />
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <DialogTitle id='form-dialog-title'>
            {formik.values.clientName}
          </DialogTitle>

          <form onSubmit={formik.handleSubmit}>
            <Grid item xs={12} sm={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                id='aliasName'
                name='aliasName'
                label='Nimetus'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.aliasName}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                margin='dense'
                id='carNr'
                name='carNr'
                label='Auto reg nr'
                type='text'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.carNr}
              />
              {formik.touched.carNr && formik.errors.carNr ? (
                <div className={classes.error}>{formik.errors.carNr}</div>
              ) : null}
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                margin='dense'
                id='carModel'
                label='Auto Mark'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.carModel}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                margin='dense'
                id='carOdo'
                label='Odomeeter'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.carOdo}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                multiline
                rows={3}
                margin='dense'
                id='driverInfo'
                label='Juhi Info'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.driverInfo}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                multiline
                rows={6}
                margin='dense'
                id='carHistory'
                label='Auto ajalugu'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.carHistory}
              />
            </Grid>
            <div className={classes.buttons}>
              <Button
                type='submit'
                className={classes.button}
                disabled={formik.isSubmitting || formik.isValidating}
              >
                Muuda
              </Button>
              <Button onClick={handleCancel} className={classes.button}>
                Tagasi
              </Button>
            </div>
          </form>
        </Paper>
      </main>
    </React.Fragment>
  )
}
